import { render, staticRenderFns } from "./ListApraisal.vue?vue&type=template&id=2b653206&scoped=true&"
import script from "./ListApraisal.vue?vue&type=script&lang=js&"
export * from "./ListApraisal.vue?vue&type=script&lang=js&"
import style0 from "./ListApraisal.vue?vue&type=style&index=0&id=2b653206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b653206",
  null
  
)

export default component.exports